import React from 'react';
import Box from '@mui/material/Box';
import { styled, keyframes } from '@mui/material/styles';

const barPulse = keyframes`
    0% {
        transform: scaleY(0.08);
        opacity: 0.3;
        fill: #317EFE;
    }
    40% {
        transform: scaleY(1);
        opacity: 1;
        fill: #317EFE;
    }
    50% {
        transform: scaleY(1);
        opacity: 1;
        fill: #8EF8E0;
    }
    90% {
        transform: scaleY(0.08);
        opacity: 0.3;
        fill: #8EF8E0;
    }
    100% {
        transform: scaleY(0.08);
        opacity: 0.3;
        fill: #317EFE;
    }
`;

const StyledSvg = styled('svg')({
    width: '48px',
    height: '62px',
    '& .bar': {
        fill: '#317EFE',
        transformBox: 'fill-box',
        transformOrigin: 'bottom center',
        animation: `${barPulse} 1.4s ease-in-out infinite`,
    },
    '& .bar-1': {
        animationDelay: '0s',
    },
    '& .bar-2': {
        animationDelay: '0.15s',
    },
    '& .bar-3': {
        animationDelay: '0.3s',
    },
    '& .bar-4': {
        animationDelay: '0.45s',
    },
});

interface AnimatedLogoProps {
    width?: number | string;
    height?: number | string;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ width = 48, height = 62 }) => {
    return (
        <Box display="inline-flex" alignItems="center" justifyContent="center">
            <StyledSvg
                width={width}
                height={height}
                viewBox="0 0 24 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    className="bar bar-1"
                    d="M0 10.7093C0 9.78985 0 9.33015 0.296654 9.07882C0.593309 8.8275 1.04676 8.90304 1.95366 9.05411L3.56653 9.3228C4.23622 9.43436 4.57107 9.49014 4.76991 9.72485C4.96874 9.95955 4.96874 10.299 4.96874 10.978V19.0425C4.96874 19.9854 4.96874 20.4568 4.66319 20.7086C4.35762 20.9603 3.89489 20.87 2.96941 20.6894L1.35653 20.3746C0.707378 20.248 0.382799 20.1845 0.191399 19.9522C0 19.7198 0 19.3892 0 18.7277V10.7093Z"
                />
                <path
                    className="bar bar-2"
                    d="M6.10589 17.5936C6.10589 16.6448 6.10589 16.1704 6.41363 15.9187C6.72139 15.667 7.18637 15.761 8.11631 15.949L9.87118 16.3037C10.5153 16.434 10.8374 16.4991 11.027 16.7308C11.2166 16.9626 11.2166 17.2913 11.2166 17.9484V28.8686C11.2166 29.7986 11.2166 30.2636 10.9159 30.5152C10.6152 30.7666 10.1575 30.6845 9.24218 30.5202L7.48733 30.2052C6.82698 30.0867 6.49678 30.0273 6.30133 29.7936C6.10589 29.56 6.10589 29.2245 6.10589 28.5536V17.5936Z"
                />
                <path
                    className="bar bar-3"
                    d="M12.6546 0.155225C12.3491 0.406913 12.3491 0.878124 12.3491 1.82054V21.2476C12.3491 21.9078 12.3491 22.238 12.54 22.4701C12.7309 22.7023 13.0548 22.7662 13.7026 22.8938L15.4573 23.2398C16.3841 23.4226 16.8474 23.514 17.1537 23.2623C17.4599 23.0105 17.4599 22.5382 17.4599 21.5936V2.16195C17.4599 1.50017 17.4599 1.16928 17.2683 0.936869C17.0768 0.704458 16.752 0.641269 16.1023 0.514891L14.3476 0.173491C13.4224 -0.00647886 12.9599 -0.0964632 12.6546 0.155225Z"
                />
                <path
                    className="bar bar-4"
                    d="M18.5977 8.76691C18.5977 7.82848 18.5977 7.35927 18.9016 7.10764C19.2053 6.856 19.6663 6.94347 20.5883 7.1184L22.3432 7.45136C22.9962 7.57526 23.3228 7.63721 23.5156 7.87002C23.7083 8.10285 23.7083 8.43519 23.7083 9.09988V17.2073C23.7083 18.1457 23.7083 18.615 23.4044 18.8666C23.1007 19.1182 22.6397 19.0307 21.7177 18.8558L19.9628 18.5228C19.3098 18.399 18.9832 18.337 18.7904 18.1042C18.5977 17.8714 18.5977 17.5391 18.5977 16.8743V8.76691Z"
                />
            </StyledSvg>
        </Box>
    );
};

export default AnimatedLogo;
